define('uikit/collections/tabs',['require','exports','module','underscore','marionette','../channel','templates','./container','../modules/menu','../definitions/modules/accordion'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var channel = require('../channel');
  var Templates = require('templates');
  var ContainerView = require('./container');
  var Menu = require('../modules/menu');
  require('../definitions/modules/accordion');

  var Tab = ContainerView.extend({

    className: 'ui tab',

    template: function() {
      return '<ui name="content"></ui>';
    },

    options: {
      active: false,
      attached: 'bottom',
      fitted: false,
      basic: false,
      loading: false,
      menuItem: null,
      segment: true,
      padded: false,
      horizontalNavMode: false,
      routeName: null
    },

    forceUpdate: { attached: true, menuItem: true },

    initialize: function() {
      ContainerView.prototype.initialize.apply(this, arguments);

      this.listenTo(this.menuItem, 'press', function() {
        var eventName = (this.menuItem.getOption('horizontalNavMode')) ? 'tab:route:resolve' : 'activated';
        var methodArgument = (this.menuItem.getOption('horizontalNavMode')) ? this.menuItem : this;

        this.triggerMethod(eventName, methodArgument);
      });
    },

    updateAttributes: function() {
      this.menuItem.active = this.getBoolOption('active');

      this.menuItem.updateElementAttributes({
        'aria-selected': this.getBoolOption('active')
      })

      this
        .addClass('active', this.getBoolOption('active'))
        .addClass(this.getOption('attached') + ' attached', this.getBoolOption('attached'))
        .addClass('loading', this.getBoolOption('loading'))
        .addClass('segment', this.getBoolOption('segment'))
        .addClass('basic', this.getBoolOption('basic'))
        .addClass('fitted', this.getBoolOption('fitted'))
        .addClass('padded', this.getBoolOption('padded'))
    }

  });

  var Tabs = ContainerView.extend({

    className: '',

    template: function() {
      return '<ui name="menu"></ui>';
    },

    ui: {
      contents: '.content'
    },

    options: {
      openTabIndex : 0,
      visible      : true,
      attached     : 'top',
      color        : '',
      dark         : false,
      tabular      : true,
      fluid        : false,
      padded       : false
    },

    forceUpdate: { attached: true },

    initialize: function() {
      ContainerView.prototype.initialize.apply(this, arguments);

      if (!this.menu) {
        this.menu = new Menu();
        this.menu.fluid = this.fluid;
        this.menu.dark = this.dark;
        this.menu.tabular = this.tabular;
        this.menu.attached = this.attached;
        this.menu.color = this.color;
        this.menu.updateElementAttributes({'role': 'tablist'});
      }

      this.listenTo(this.menu, 'add', function(childView) {
        childView.updateElementAttributes({
          'id': childView.getOption('name') + 'Tab',
          'role': 'tab',
          'aria-controls': childView.getOption('name') + 'Panel'
        });

        this.listenTo(childView, 'change:visible', function() {
          var tabIndex = this.menu.indexOf(childView);
          if (tabIndex === this.openTabIndex) {
            this.openTabIndex = this.findNextVisibleTab();
          }
        });
      });
    },

    findNextVisibleTab: function() {
      var menuItemViews = this.menu.toArray();
      for (var i = 0; i < menuItemViews.length; ++i) {
        if (menuItemViews[i].visible) {
          return i;
        }
      }
      return -1;
    },

    onChangeAttached: function() {
      this.menu.attached = this.attached;
    },

    onChangeColor: function() {
      this.menu.color = this.color;
    },

    onChangeFluid: function() {
      this.menu.fluid = this.fluid;
    },

    onChangeDark: function() {
      this.menu.dark = this.dark;
    },

    onChangeTabular: function() {
      this.menu.tabular = this.tabular;
    },

    onChangePadded: function() {
      this.each(function(view) {
        view.padded = this.padded;
      }, this)
    },

    onFirstRender: function() {
      this.on("change:openTabIndex", this.onOpenTabIndexChange);
    },

    add: function(tabItemView, contentView, fn) {
      var tabContentView = null;

      if (_.isString(tabItemView)) {
        tabItemView =  new Menu.Item({
          text: tabItemView,
          link: true
        });
      }

      this.menu.add(tabItemView);

      tabContentView = new Tab({
        content: contentView,
        menuItem: tabItemView,
        padded: this.getOption('padded')
      });

      tabContentView.updateElementAttributes({
        'id': tabItemView.getOption('name') + 'Panel',
        'role': 'tabpanel',
        'aria-labelledby': tabItemView.getOption('name') + 'Tab',
        'aria-hidden': 'true',
        'tabindex': '0'
      });

      if (_.isFunction(fn)) {
        fn.call(this, tabContentView);
      }

      this.listenTo(tabContentView, 'activated', function(view) {
        this.openTabIndex = this.indexOf(view);
      });

      return ContainerView.prototype.add.call(this, tabContentView);
    },

    onOpenTabIndexChange: function(self, newValue, oldValue) {
      this._activateTab(newValue, parseInt(oldValue));
    },

    _activateTab: function(newIndex, previousIndex) {
      if (_.isNumber(previousIndex) && this.at(previousIndex)) {
        this.at(previousIndex).active = false;
        this.at(previousIndex).updateElementAttributes({'aria-hidden': 'true'});
      }
      if (this.at(newIndex)) {
        this.at(newIndex).active = true;
        this.at(newIndex).updateElementAttributes({'aria-hidden': 'false'});
      }
    },

    open: function(index) {
      this.openTabIndex = index;

      return this;
    },

    onRender: function() {
      this.$el.prepend(this.menu.$el);
      this.menu.render();
    },

    onAfterRenderAll: function() {
      this._activateTab(this.openTabIndex);
    },

    onRemove: function(view) {
      this.menu.remove(view);
    },

    onBeforeDestroy: function() {
      if (this.menu) {
        this.menu.destroy();
      }
    }

  });

  Tabs.Tab = Tab;

  channel.reply('tabs', function() {
    return Tabs;
  });

  module.exports = Tabs;
});

